<div
  class="waiting-room-table-container"
  [style]="{
    height: visitOrdersStore.checkedForRejected().data.length ? '50vh' : '25vh',
    minHeight: visitOrdersStore.checkedForRejected().data.length ? '750px' : '400px'
  }"
>
  <lib-table
    [pagination]="currentPagination"
    [savePageLocalStorageKey]="savePageLocalStorageKey"
    [itemsPerPageOptions]="itemsPerPageOptions"
    (paginationChange)="onPaginationChange($event)"
    [isLoading]="visitOrdersStore.orders().isLoading"
    [data]="visitOrdersStore.checkedForRejected().data"
    [localSort]="false"
    [noDataMessage]="noDataMessage"
    [paginated]="true"
  >
    <thead table-header class="table-header-container">
    <tr>
      @for (tableHeader of headers; track tableHeader.id) {
        @if (tableHeader.sortValue) {
          <th #header libSortable (onSortChanged)="onSort($event)" [sortableField]="tableHeader.sortValue" [sortableFields]="sortableFields">
            @if (tableHeader.tooltip) {
              <span class="relative text-center" matTooltip="{{tableHeader.tooltip}}">{{tableHeader.text}}</span>
            } @else if (!tableHeader.tooltip) {
              <span>{{tableHeader.text}}</span>
            }
            @if (visitOrdersStore.searchQuery().sort === tableHeader.sortValue) {
              <i class="ion-chevron-{{tableHeader.sortDirection}}"></i>
            }
          </th>
        } @else {
          <th #header>
            @if (tableHeader.tooltip) {
              <span class="relative text-center" matTooltip="{{tableHeader.tooltip}}">{{tableHeader.text}}</span>
            } @else if (!tableHeader.tooltip) {
              <span>{{tableHeader.text}}</span>
            }
            @if (visitOrdersStore.searchQuery().sort === tableHeader.sortValue) {
              <i class="ion-chevron-{{tableHeader.sortDirection}}"></i>
            }
          </th>
        }
      }
    </tr>
    </thead>
    <tbody table-rows class="table-body-container">
      @for (order of visitOrdersStore.checkedForRejected().data; track order.id) {
        <tr #row class="table-body" [ng-ui-sref]="{ state: 'visitDetail', params: { id: order.id } }">
          <td>
            @if (order.answer_status) {
              <i class="icon-dot status-{{order.answer_status}}"></i>
            }
          </td>
          <td>
            @if (order.has_rejected) {
              <i class="icon-intl-no-b color-alert"></i>
            }
          </td>
          <td>
            @if (order.flags.blocked) {
              <span class="relative" matTooltip="{{order.blocked_message}}" matTooltipPosition="above">
							<i class="{{order.blocked_action === 'PST' ? 'icon-flag color-pst' : 'icon-flag color-alert'}}"></i>
						</span>
            }
          </td>
          <td>{{ order.paid | date:"dd/MMM/yy, H:mm a" }}</td>
          <td class="strong">{{ order.user | fullname }}</td>
          <td>{{ order.id }}</td>
          <td>
            <div style="float: right">
              @if (order.is_fast_track) {
                <i class="icon-ic-noun-fast color-alert" style="font-size: 20px; line-height: 0.8; color: #4CAED6; margin-right: 5px;"></i>
              }
              @else if (order.flags.mailorder) {
                <i class="icon-deliverytruck" style="font-size: 20px; line-height: 0.8; color: #4CAED6; margin-right: 5px;"></i>
              }
            </div>
            <span class="strong system-code-color-{{order.user.system_code}}">
						{{order.service.name + ' '}}
					</span>
            @if (order.user.visit_counts[order.service.code]) {
              <span class="strong">
						({{ order.user.visit_counts[order.service.code].total }})
						</span>
            }
          </td>
          <td>
            {{!order.prescribed_medication_names?.length ? order.default_medication.name : order.prescribed_medication_names?.join(', ')}}
          </td>
          <td>
            @if (order.queue_entry) {
              <span class="total_entry_wait_time">{{order.queue_entry}}</span>
            }
          </td>
          <td>
					<span
            class="strong"
            [style.color]="[5.5, 5.7, 5.9, 5.71, 5.51].includes(order.admin_status) ? '#ff5f1c' :
										 [4.5, 4.7, 4.9, 4.71].includes(order.admin_status) ? '#77c660' :
										 '#8e91a6'">
						{{ order | humanisedStatus }}
					</span>
          </td>
          <td>
            @if (!order.phone_call.last_called){
              <span>{{order.phone_call.last_called| date:"dd/MMM/yy, H:mm a"}}</span>
            }
          </td>
          <div>
            <i style="padding: 10px" class="ion ion-chevron-right color-gray-md ng-scope"></i>
          </div>
        </tr>
      }
    </tbody>
  </lib-table>

</div>
